module.exports = __webpack_public_path__ + "b8a7491755e1c78ac3e8cb0c75b115ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/apple.png
// module id = 1775
// module chunks = 0